import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'pine' | 'rust' | 'neutral';
  className?: string;
}
const tones: Record<string, string> = {
  pine: 'bg-pine text-paper-soft',
  rust: 'bg-rust text-paper-soft',
  neutral: 'bg-paper-deep text-ink'
};
export function Pill({
  children,
  tone = 'pine',
  className = ''
}: PillProps) {
  return <span className={`inline-flex items-center rounded-md px-3.5 py-1.5 font-display text-xs font-semibold uppercase tracking-[0.18em] ${tones[tone]} ${className}`} style={{
    fontSize: "10px"
  }} data-id="element-174" data-mp="n8v9zre6xcja">
      {children}
    </span>;
}